export const coursePlanMap = {
    0: '0%',
    1: '100%',
    2: '75%',
    3: '25%',
    4: '50%'
}